import { Resources } from 'constants/resources';

import { TextInputProps, useGetOne, useInput } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { IconButton } from 'shared/mui/IconButtons';
import { GenerateTextIconStyled } from 'shared/mui/Icons';
import { Tooltip } from 'shared/mui/Tooltip/Tooltip/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { TextInput } from 'shared/react-admin/Inputs';

export type MerchantsShowCredentialsNameInputProps = {
  merchantName?: string;
} & TextInputProps;

export function MerchantsShowCredentialsNameInput({
  merchantName,
  ...rest
}: MerchantsShowCredentialsNameInputProps): JSX.Element {
  const { field } = useInput({ source: rest.source });

  const providerId = useWatch({ name: 'provider' });
  const { data: provider } = useGetOne(
    Resources.Providers,
    { id: providerId },
    { enabled: !!providerId },
  );

  return (
    <TextInput
      {...rest}
      InputProps={{
        endAdornment: (
          <Tooltip title={<Typography fontSize={12}>Сгенерировать название</Typography>}>
            <span>
              <IconButton
                disabled={!provider?.name}
                onClick={() => field.onChange([merchantName, provider?.name].join(' '))}
              >
                <GenerateTextIconStyled disabled={!provider?.name} />
              </IconButton>
            </span>
          </Tooltip>
        ),
      }}
    />
  );
}
